<ng-container *transloco="let _t">

{{content | slice:0:len}} <a *ngIf="content.length>max" (click)="toggleMax()">{{toggleWord}}</a>

</ng-container>